var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-datepicker',{attrs:{"user-format":"G:i K","date-format":"G:i K","timepicker":"","clearable":false,"datepicker":false,"amPm":true,"variant":{
    timepicker: true,
  },"loading":_vm.loading,"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }